import LongInput from './LongInput';

export default LongInput;
